import { composeValidators, createValidator, required, richTextMaxLength } from 'util/validation'

import {
  IntervencoesProcedimentosPlanoModel,
  ProcedimentosPlanoModel,
} from '../components/IntervencoesProcedimentosView'
import { ALERTA_PROCEDIMENTO_INATIVO } from '../model-plano'
import { PlanoFormModel } from '../PlanoForm'

const procedimentosPlanoAtivosValidator = createValidator<ProcedimentosPlanoModel>(
  {},
  (values: ProcedimentosPlanoModel) => {
    const hasProcedimentoInativo =
      values?.procedimentos?.some((procedimento) => procedimento.procedimento?.ativo === false) ?? false

    return hasProcedimentoInativo ? { procedimentos: ALERTA_PROCEDIMENTO_INATIVO } : {}
  }
)

const procedimentosPlanoRequiredValidator = createValidator<ProcedimentosPlanoModel>({
  procedimentos: [required],
})

export const intervencoesProcedimentosCommonValidator = createValidator<IntervencoesProcedimentosPlanoModel>({
  procedimentosPlano: procedimentosPlanoAtivosValidator,
})

export const intervencoesProcedimentosValidator = createValidator<IntervencoesProcedimentosPlanoModel>({
  procedimentosPlano: composeValidators(procedimentosPlanoAtivosValidator, procedimentosPlanoRequiredValidator),
})

export const planoProcedimentosValidator = () =>
  createValidator<PlanoFormModel>({
    texto: [richTextMaxLength(4000)],
    intervencoesProcedimentos: intervencoesProcedimentosValidator,
  })
